export default __webpack_public_path__ + "static/media/branding-logo.5a5b125c.svg";